import workspaceQuery from 'graphql/queries/salesLedger/SalesInvoiceLineWorkspaceQuery.graphql';
import aggregateQuery from 'graphql/queries/salesLedger/SalesInvoiceLineAggregateQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { SalesInvoiceFormAction } from '../../../actions/salesLedger/salesInvoice/SalesInvoiceAction';

const SalesInvoiceLine: EntityType = {
  type: 'SalesInvoiceLine',
  title: 'Sales Invoice Lines',
  workspace: workspaceQuery,
  workspaceUrl: '/Customers/InvoiceLine/Workspace/',
  formTitle: 'Sales Invoice',
  formUrl: '/Customers/Invoice/Details/',
  aggregate: aggregateQuery,
  screenReference: 'SALES_LEDGER_INVOICE_LINES',
  dropdown: {
    query: workspaceQuery,
    valueKey: 'id',
    labelKey: 'id',
  },
  actions: [
    { actionReference: SalesInvoiceFormAction.ReturnOrder },
    { actionReference: SalesInvoiceFormAction.CreditRefundInvoice },
  ],
};

export default SalesInvoiceLine;
